export function gettoken() {
    // return sessionStorage.getItem("token")
    return localStorage.getItem("token")
}

export function settoken(token) {
    // sessionStorage.setItem("token", token)
    localStorage.setItem("token", token)
}